"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function handleResponse(query, handlers) {
    const { response } = query;
    if (handlers && response.status && handlers[response.status]) {
        const handler = handlers[response.status];
        return handler(query) || query;
    }
    return query;
}
exports.default = handleResponse;
